import { useCallback, useEffect, useState } from "react";
import { getMasterData } from "../../services/masterDataService";
import { SUCCESS_CODE } from "../const";

const useMasterData = (type, topicKey) => {
  const [data, setData] = useState([]);
  const [options, setOptions] = useState([]);

  const fetchData = useCallback(async () => {
    const res = await getMasterData(type, topicKey);
    if (res.data.code === SUCCESS_CODE) {
      const { objectValue } = res.data;
      setData(objectValue);
      const transformedOptions = [
        { label: "เลือกทั้งหมด", value: "all" },
        ...objectValue.map((item) => ({
          label: item.dataDetailTh,
          value: item.dataId,
        })),
      ];
      setOptions(transformedOptions);
    }
  }, [setData, topicKey, setOptions]);

  useEffect(() => {
    fetchData();
  }, [fetchData]);

  return [data, options];
};

export default useMasterData;
